import { profile } from '../data/profile';
import { Reveal } from '../components/Reveal';
import './About.css';

export function About() {
  return (
    <section id="about" className="section about">
      <Reveal direction="left" className="about-photo-wrap">
        <div className="about-photo glass">
          {profile.photo ? (
            <img src={profile.photo} alt={profile.name} />
          ) : (
            <span className="about-photo__monogram">{profile.initials}</span>
          )}
          <div className="about-photo__ring" aria-hidden="true" />
        </div>
      </Reveal>

      <div className="about-text">
        <Reveal>
          <p className="eyebrow">{'// About me'}</p>
          <h2 className="section-title">
            Builder of <span className="grad">apps, AI &amp; robots</span>
          </h2>
        </Reveal>

        {profile.bio.map((para, i) => (
          <Reveal key={i} delay={i + 1}>
            <p className="about-para">{para}</p>
          </Reveal>
        ))}

        <Reveal delay={3} className="about-stats-wrap">
          <div className="about-stats">
            {profile.stats.map((s) => (
              <div className="about-stat" key={s.label}>
                <span className="about-stat__value">{s.value}</span>
                <span className="about-stat__label">{s.label}</span>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
